import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=f0979058&scoped=true"
import script from "./Compare.vue?vue&type=script&lang=ts"
export * from "./Compare.vue?vue&type=script&lang=ts"
import style0 from "./Compare.vue?vue&type=style&index=0&id=f0979058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0979058",
  null
  
)

export default component.exports